import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular';
import { KeysPipe } from 'src/app/shared/pipes/keys.pipe';

@Component({
  selector: 'app-popup-dettaglio-log-azioni',
  templateUrl: './popup-dettaglio-log-azioni.component.html',
  styleUrls: ['./popup-dettaglio-log-azioni.component.scss'],
  imports: [DxPopupComponent, CommonModule, KeysPipe],
})
export class PopupDettaglioLogAzioniComponent implements OnInit {
  @Input() rigaDettaglio: any;
  @Output() dettaglioLogAzioniPopupEventEmitter = new EventEmitter<boolean>();

  datiObj: any;
  dettaglioObj: any;

  ngOnInit() {
    this.loadObjs();
  }

  loadObjs() {
    try {
      this.datiObj = JSON.parse(this.rigaDettaglio?.logAzioni?.dati);
    } catch (error) {
      console.log('Impossibile effettuare il parsing dei dati');
    }
    try {
      this.dettaglioObj = JSON.parse(this.rigaDettaglio?.logAzioni?.dettaglio);
    } catch (error) {
      console.log('Impossibile effettuare il parsing del dettaglio');
    }
  }

  onPopupCloseClick() {
    this.dettaglioLogAzioniPopupEventEmitter.emit(true);
  }
}
